import { Component, HostListener, OnInit, Renderer2 } from '@angular/core';
import { NavigationEnd, Router, Event, ActivatedRoute } from '@angular/router';
import { CommonService } from './provide/common.service';
import { AuthService } from './provide/auth.service';

declare var $: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'exobe-web';
  currUrl: any;
  view: boolean = true;
  isChatbotOpen: boolean = false;
  isDocumentOnly: boolean = false;
  isPdfViewing: boolean = false;

  constructor(
    public commonService: CommonService, 
    public routes: Router, 
    public authService: AuthService,
    private renderer: Renderer2
  ) {
    localStorage.getItem('userFirstVisit') ? '' : this.openPopupModal();
    routes.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd) {
        this.currUrl = event.url.split('/')[1];
        
        // Check if this is a document-only route
        this.isDocumentOnly = event.url.includes('-document');
        
        // Check if we're viewing a PDF (routes containing about, privacy, terms)
        this.isPdfViewing = event.url.includes('about') || 
                           event.url.includes('privacy') || 
                           event.url.includes('terms');
        
        // Add or remove document-only class on body
        if (this.isDocumentOnly) {
          this.renderer.addClass(document.body, 'document-only');
        } else {
          this.renderer.removeClass(document.body, 'document-only');
        }
        
        // Add or remove pdf-viewing class on body
        if (this.isPdfViewing) {
          this.renderer.addClass(document.body, 'pdf-viewing');
        } else {
          this.renderer.removeClass(document.body, 'pdf-viewing');
        }
        
        if (this.currUrl == 'user-not-approved') {
          this.view = false;
        } else {
          this.view = true;
        }
      }
    });

    // Listen for PDF viewer events
    this.commonService.pdfViewingState.subscribe((isViewing: boolean) => {
      this.isPdfViewing = isViewing;
      if (isViewing) {
        this.renderer.addClass(document.body, 'pdf-viewing');
      } else {
        this.renderer.removeClass(document.body, 'pdf-viewing');
      }
    });
  }

  ngOnInit(): void {
    // No ned to disable scrolling
  }

  toggleChatbot(): void {
    this.isChatbotOpen = !this.isChatbotOpen;
  }

  handleUnload(event: Event): void {}

  openPopupModal() {
    setTimeout(() => {
      $("#exampleModal").modal({backdrop: 'static', keyboard: false}, "show");
    }, 2000);
  }

  navigateTo(userType: string) {
    this.authService.logout();
    $("#exampleModal").modal("hide");
    localStorage.setItem('userFirstVisit', "true");
    localStorage.setItem('userType', userType);
    if (userType == 'CUSTOMER') {
      this.commonService.userTypeSelectionUpdate.next(userType);
      this.routes.navigate(['/home']);
    } else if (userType == 'RETAILER') {
      this.commonService.userTypeSelectionUpdate.next(userType);
      this.routes.navigate(['/login']);
    } else {
      this.commonService.userTypeSelectionUpdate.next(userType);
      this.routes.navigate(['/login-service-provider']);
    }
  }
}